import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import { getCategoryName } from "@/utils/news";

export default function ProgressList() {
  const ordered = [...topics]
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
    .slice(0, 5);

  return (
    <section id="progress" className="scroll-mt-24">
      <div className="flex items-end justify-between gap-4">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">正在发酵</h2>
          <p className="mt-2 text-sm text-foreground-600">按最近更新时间排列，点开就是完整时间线。</p>
        </div>
      </div>

      <ol className="mt-8 space-y-1">
        {ordered.map((topic, index) => (
          <li key={topic.id} className="relative flex gap-4 pb-6">
            <div className="flex flex-col items-center">
              <span
                className={`mt-1 flex h-8 w-8 shrink-0 items-center justify-center rounded-full font-heading text-xs font-bold ${
                  index === 0
                    ? "bg-primary-500 text-background-50"
                    : "border border-background-300 bg-background-50 text-foreground-600"
                }`}
              >
                {index + 1}
              </span>
              {index !== ordered.length - 1 && (
                <span className="mt-1 w-px flex-1 bg-background-300"></span>
              )}
            </div>

            <div className="min-w-0 flex-1 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300">
              <div className="flex flex-wrap items-center gap-2 text-xs">
                <span className="rounded-full bg-background-200 px-2 py-0.5 font-medium text-foreground-700">
                  {getCategoryName(topic.category)}
                </span>
                <span className="flex items-center gap-1 text-foreground-500">
                  <i className="ri-time-line text-sm" aria-hidden="true"></i>
                  {topic.updatedAt}
                </span>
              </div>
              <Link to={`/topic/${topic.id}`} className="group mt-2 block">
                <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                  {topic.title}
                </h3>
              </Link>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                <span className="font-medium text-foreground-800">最新进展：</span>
                {topic.timeline[topic.timeline.length - 1].desc}
              </p>
              <div className="mt-3 flex flex-wrap gap-2">
                {topic.tags.map((tag) => (
                  <span key={tag} className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-800">
                    # {tag}
                  </span>
                ))}
              </div>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}